import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { useIsBreakpointSize } from 'app/shared/utils/useBreakpoint';
import { Box, LoadingBlock, Logo } from 'app/shared/components/atoms';

import { BasePageBox } from './BasePageBox';

export const NavbarLoadingBlocks = () => {
  const { colors } = useCurrentTheme();
  const { isDesktop } = useIsBreakpointSize();
  const height = isDesktop ? '90px' : '158px';

  return (
    <LoadingBlock h={height} w="100%" mb={[4, 0, 0, 0]}>
      <BasePageBox
        py={[8, 8, 6, 6]}
        bt={colors.accent.primaryAccent.base}
        bb={colors.accent.primaryAccent.base}
      >
        <Box h="40px" alignItems="center">
          <Logo
            variant="primary"
            fillColor={colors.accent.primaryAccent.base}
            height={32}
          />{' '}
        </Box>
      </BasePageBox>
    </LoadingBlock>
  );
};
